import { Link, useLocation } from "react-router-dom";
import { navItems } from "@/mocks/site";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="font-heading text-7xl font-900 text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-700 text-foreground-950 md:text-3xl">
        这个页面好像不存在
      </h1>
      <p className="mt-3 text-sm text-foreground-600 md:text-base">
        你访问的地址
        <span className="mx-1 rounded bg-background-200/70 px-2 py-0.5 font-mono text-xs text-foreground-700">
          {location.pathname}
        </span>
        没有找到对应内容，可能是链接有误或者页面已调整。
      </p>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-500 text-foreground-800 transition-colors hover:bg-background-100"
        >
          <i className="ri-stack-line" aria-hidden="true"></i>
          浏览作品库
        </Link>
      </div>

      <div className="mt-12 w-full rounded-xl border border-background-200 bg-background-50 p-6">
        <h2 className="font-heading text-base font-600 text-foreground-950">你可能想去这些地方</h2>
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="whitespace-nowrap rounded-full bg-background-100 px-4 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}